import React from "react";
import { Calendar } from "antd";
import moment from "moment";
import styled from "styled-components";

const PopoverDiv = styled.div`
  width: 300px;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
`;

export default function CalendarPopover({ onUpdate, date }) {
  const onChange = (value) => {
    const date = moment(value).format("YYYY-MM-DD");
    onUpdate({ date: date });
  };
  const minDate = moment().subtract(1, "d");
  return (
    <PopoverDiv>
      <Calendar
        fullscreen={false}
        onChange={onChange}
        defaultValue={moment(date)}
        disabledDate={
          minDate ? (current) => current && current < minDate : undefined
        }
      />
    </PopoverDiv>
  );
}
